import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelPhys.mjs'

export const FormItemIp = props => (
    <FormItemBizProp
        Model={Model}
        prop="ip"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemPsName = props => (
    <FormItemBizProp
        Model={Model}
        prop="psName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChoosePhys(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemPsName />
            <FormItemIp />
        </FormChooseDesign>
    )
}
